<template>
  <div v-if="hasUnassigned" class="inline-flex items-center">
    <!-- Badge с количеством -->
    <span
      class="inline-flex items-center justify-center px-2.5 py-1 text-xs font-semibold rounded-full transition-colors"
      :class="badgeColorClasses"
      :title="`Непривязанных товаров: ${count}`"
    >
      <UIcon 
        v-if="showIcon" 
        name="i-heroicons-exclamation-triangle" 
        class="w-3.5 h-3.5 mr-1" 
      />
      <span>{{ count }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useUnassignedProducts } from '@fsd-pages/admin';

interface Props {
  /** Автоматически загружать данные при монтировании */
  autoLoad?: boolean;
  /** Показывать иконку предупреждения */
  showIcon?: boolean;
  /** Цветовая схема badge */
  variant?: 'warning' | 'danger' | 'info';
}

const props = withDefaults(defineProps<Props>(), {
  autoLoad: true,
  showIcon: true,
  variant: 'warning',
});

const { unassignedCount, hasUnassigned, fetchUnassignedCount } = useUnassignedProducts();

const count = computed(() => unassignedCount.value);

const badgeColorClasses = computed(() => {
  switch (props.variant) {
    case 'danger':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
    case 'info':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
    case 'warning':
    default:
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300';
  }
});

onMounted(async () => {
  if (props.autoLoad) {
    await fetchUnassignedCount();
  }
});

// Expose функцию для ручного обновления
defineExpose({
  refresh: fetchUnassignedCount,
});
</script>

